import { graphql } from '@tn/foundation/graphql/__generated/gql';

export const changePasswordCacheKey = 'changePassword';
export const changePasswordMutation = graphql(/* GraphQL */ `
    mutation ChangePassword(
        $token: String!
        $password: String!
        $passwordConfirm: String!
        $recaptchaToken: String
    ) {
        changePassword(
            token: $token
            password: $password
            passwordConfirm: $passwordConfirm
            recaptchaToken: $recaptchaToken
        ) {
            success
            isReLoginSuccess
        }
    }
`);
